/**
 * hex转rgb
 * @param {string} str  色值，如：#409EFF #FFF
 * @param {alpha} number 透明度 0 - 1，传值就返回rgba
 * @returns rgb数组[64, 158, 255] rgba数组[64, 158, 255, 0.6]
 */
export const toRgb = (str, alpha = 1) => {
  if (str.startsWith('rgb')) {
    return str;
  }
  const reg3 = /^\#?[0-9A-Fa-f]{3}$/;
  const reg6 = /^\#?[0-9A-Fa-f]{6}$/;
  if (!reg3.test(str) && !reg6.test(str)) return str;

  let hexs = null;
  str = str.replace('#', ''); // 去掉#
  if (str.length === 3) {
    str = str.replace(/(.)/g, '$1$1');
  }
  hexs = str.match(/../g); // 切割成数组 409EFF => ['40','9E','FF']
  // 将切割的色值转换为16进制
  for (let i = 0; i < hexs.length; i++) hexs[i] = parseInt(hexs[i], 16);
  if (!isNaN(alpha)) {
    alpha = alpha > 1 ? 1 : alpha < 0 ? 0 : alpha;
    hexs.push(alpha);
  }
  return `rgba(${hexs.join(',')})`; // 返回rgb色值[64, 158, 255]
};

export const getRGBA = (str) => {
  const [r, g, b, a] = toRgb(str)
    .replace(/rgba?/, '')
    .replace('(', '')
    .replace(')', '')
    .split(',')
    .map((item) => item.trim());
  return { r, g, b, a };
};

export function toHex(str) {
  if (!str.startsWith('rgb')) {
    str = toRgb(str);
  }
  const [r, g, b] = str
    .replace(/rgba?/, '')
    .replace('(', '')
    .replace(')', '')
    .split(',')
    .map((item) => item.trim());
  return '#' + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1);
}
